export const LDClientIDs = {
  // The key in this object matches the environments in Launch Darkly
  prd: '61b255ee4a1a460d5c66647d',
  perf: '61b255cbf764780d3adb58c1',
  int: '61b255b8f764780d3adb58b2',
  dev: '61b254004a1a460d5c666420',
};

export function getLaunchDarklyClientSideID(env) {
  let LDClientSideID = null;
  switch (env) {
    case 'local':
    case 'development':
    case 'automation':
      LDClientSideID = LDClientIDs.dev;
      break;
    case 'integration':
      LDClientSideID = LDClientIDs.int;
      break;
    case 'cert':
      LDClientSideID = LDClientIDs.perf;
      break;
    case 'production':
      LDClientSideID = LDClientIDs.prd;
      break;
    default:
      throw new Error(`Unknown env when initializing Launch Darkly. Env: ${env}`);
  }

  return LDClientSideID;
}

export function filterReportsFromFlags(allReportDetails, launchDarklyFlags) {
  /* For every report, see if there is a launchDarklyToggleFlagName property defined
   * If there is, use that name to access the value in launchDarklyFlags
   * to determine if the report stays in the finalized array or is filtered out
   */
  return allReportDetails.filter((report) => {
    if (report.launchDarklyToggleFlagName) {
      if (launchDarklyFlags === null || launchDarklyFlags === undefined) {
        return false;
      }

      const flagValue = launchDarklyFlags[report.launchDarklyToggleFlagName];
      // If the report has a launchDarklyToggleFlagName but there is no entry for that in launchDarklyFlags, then disable the report

      return !!flagValue; // coerce things like null and undefined into false (report won't be shown)
    }

    return true;
  });
}

export function filterLaunchDarklyVersionedReports(allReportDetails, launchDarklyFlags) {
  /* For every report, see if there is a launchDarklyVersionFlagName property defined
   * If there is, use that name to access the value in launchDarklyFlags.
   * Then, filter out all reports with that given launchDarklyVersionFlagName that do not
   * match LaunchDarkly's returned version number in said flag
   * */
  return allReportDetails.filter((report) => {
    if (report.launchDarklyVersionFlagName) {
      if (launchDarklyFlags == null) {
        return false;
      }

      // If there is a launchDarklyVersionFlagName defined, then we only return true
      // if the value of the version matches this given report's version number

      const flagValue = launchDarklyFlags[report.launchDarklyVersionFlagName];
      // If the report has a launchDarklyToggleFlagName but there is no entry for that in launchDarklyFlags, then disable the report

      return flagValue === report.version;
    }

    return true;
  });
}
